import InstallNewRoof from "../Assets/Install New Roof.jpg";
import RepairRoof from "../Assets/Repair Roof.jpg";
import ReplaceRoof from "../Assets/Replace Roof.jpg";
import HighVelocitySystems from "../Assets/High-velocity systems.jpg";
import IndoorAirQuality from "../Assets/Indoor-air-quality.jpg";
import EmergencyHVAC from "../Assets/Emergency HVAC.jpg";
import DuctCleaning from "../Assets/Duct cleaning.jpg";
import ThermostatInstallation from "../Assets/Thermostat installation.jpg";
import hvacEnergyEfficiencyAudits from "../Assets/Efficiency-audits.jpg";
import ZoningSystemSetup from "../Assets/zoning-system-setup.jpg";
import CommercialHVACMaintenance from "../Assets/maintenance-plans.jpg";


import WaterExtractiontructuralDrying from "../Assets/Water Extraction & Structural Drying.png";
import DehumidificationAndAirMovers from "../Assets/Dehumidification & Air Movers.png";
import MoldPreventionRemediation from "../Assets/Mold Prevention & Remediation.jpg";
import SewageCleanup from "../Assets/Sewage Cleanup.webp";
import ContentCleaning from "../Assets/Content Cleaning & Pack Out.jpeg";
import DrywallAndFlooringRepair from "../Assets/FlooringRepair.jpg";
import EmergencyTarps  from "../Assets/Emergency Tarps .jpg";
import DustingAndPolishing  from "../Assets/Dusting & Polishing.jpg";
import VacuumingAndMopping  from "../Assets/Vacuuming & Mopping.jpg";


import HeatPumpRepair from "../Assets/Heat pump repair.jpg";
import FurnaceServices from "../Assets/Furnace services.jpg";
import iWaveFurnace from "../Assets/iWave furnace.jpg";
import HeaterRepair from "../Assets/heater repairing.jpg";
import HeaterInstallation from "../Assets/Heater installation.jpg";
import GreenHeating from "../Assets/Green heating.jpg";


import HouseCleaning from "../Assets/House Cleaning.jpg";
import ApartmentCleaning from "../Assets/Apartment Cleaning.jpg";
import OfficeCleaning from "../Assets/Office Cleaning Services.jpg";
import DeepCleaning from "../Assets/Deep Cleaning.jpg";
import CommercialCleaning  from "../Assets/Commercial Cleaning Projects.jpg";
import VacationHouseChecks  from "../Assets/Vacation House Checks.jpg";
import BathroomsCleaning  from "../Assets/Bathrooms Cleaning.jpg";
import MirrorsFixtures  from "../Assets/Mirrors & Fixtures.jpg";
import CountertopsKitchenSurfaces  from "../Assets/Countertops & Kitchen Surfaces.jpg";
import BlindsBaseboards from "../Assets/Blinds & Baseboards.jpg";
import SpringCleaning from "../Assets/Spring Cleaning.jpg";
import MoveinMoveoutCleaning from "../Assets/Move-in Moveout Cleaning.jpg";
import EventCleaning from "../Assets/Event Cleaning.jpg"
import TrashRemoval from "../Assets/Trash Removal.jpg"
import BreakRoom from "../Assets/Break Room Cleaning.png"
import Conference from "../Assets/Conference Room Cleaning.png"
import Vacation from "../Assets/Vacation House Check Mail, Plants, Storm Damage, Security Check.png"

export const servicesData = [
  {
    "id": "roofing-install-new-roof",
    "mainType": "Roofing",
    "websiteServicesUrl": "https://bestindianaroofing.com/services",
    "title": "Install New Roof",
    "slug": "install-new-roof",
    "excerpt": null,
    "description": "Installing a new roof increases curb appeal, improves energy efficiency, and ensures your home or commercial property is protected for decades.",
    "options": [
      "Asphalt",
      "Metal",
      "Shingle",
      "Other / Not Sure"
    ],
    "tags": [],
    "price": null,
    "icon": "Roofing",
    "pageUrl": "https://bestindianaroofing.com/services/install-new-roof",
    "imageUrl": InstallNewRoof
  },
  {
    "id": "roofing-repair-roof",
    "mainType": "Roofing",
    "websiteServicesUrl": "https://bestindianaroofing.com/services",
    "title": "Repair Roof",
    "slug": "repair-roof",
    "excerpt": null,
    "description": "Roof repairs can save you money by preventing costly water damage, mold, and structural issues. Our Bloomington roofing team specializes in fast emergency repairs and routine maintenance.",
    "options": [
      "Asphalt",
      "Metal",
      "Shingle",
      "Other"
    ],
    "tags": [],
    "price": null,
    "icon": "Build",
    "pageUrl": "https://bestindianaroofing.com/services/repair-roof",
    "imageUrl":RepairRoof
  },
  {
    "id": "roofing-replace-roof",
    "mainType": "Roofing",
    "websiteServicesUrl": "https://bestindianaroofing.com/services",
    "title": "Replace Roof",
    "slug": "replace-roof",
    "excerpt": null,
    "description": "Replacing your roof adds value to your property, increases energy efficiency, and ensures your home or business is fully protected against Indiana’s weather.",
    "options": [
      "Asphalt",
      "Metal",
      "Shingle"
    ],
    "tags": [],
    "price": null,
    "icon": "Autorenew",
    "pageUrl": "https://bestindianaroofing.com/services/replace-roof",
    "imageUrl":ReplaceRoof
  },
  {
    "id": "hvac-preventive-maintenance-plans",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Preventive maintenance plans",
    "slug": "preventive-maintenance-plans",
    "excerpt": "Preventive maintenance plans by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "EventRepeat",
    "pageUrl": "https://www.ritehvacservices.com/services/preventive-maintenance-plans",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-preventive-maintenance-plans.7f3435fccb58d66878ff.jpg"
  },
  {
    "id": "hvac-ac-installation",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "AC installation",
    "slug": "ac-installation",
    "excerpt": "AC installation by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "AcUnit",
    "pageUrl": "https://www.ritehvacservices.com/services/ac-installation",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-ac-installation.6fadb5bd4ef9d165261a.jpg"
  },
  {
    "id": "hvac-ac-repair",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "AC repair",
    "slug": "ac-repair",
    "excerpt": "AC repair by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Build",
    "pageUrl": "https://www.ritehvacservices.com/services/ac-repair",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-ac-repair.ee9e9482290af939f7a1.jpg"
  },
  {
    "id": "hvac-ac-replacement",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "AC replacement",
    "slug": "ac-replacement",
    "excerpt": "AC replacement by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Autorenew",
    "pageUrl": "https://www.ritehvacservices.com/services/ac-replacement",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-ac-replacement.e4c087cbbc7e9b0b0f3e.jpg"
  },
  {
    "id": "hvac-hvac-maintenance",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "HVAC maintenance",
    "slug": "hvac-maintenance",
    "excerpt": "HVAC maintenance by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Handyman",
    "pageUrl": "https://www.ritehvacservices.com/services/hvac-maintenance",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-hvac-maintenance.08acde903fdaa9715d69.jpg"
  },
  {
    "id": "hvac-boiler-services",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Boiler services",
    "slug": "boiler-services",
    "excerpt": "Boiler services by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Opacity",
    "pageUrl": "https://www.ritehvacservices.com/services/boiler-services",
    "imageUrl": "https://ritehvacservices.com/static/media/hero-service-boiler-services.fa4d86a668500a5554f7.jpg"
  },
  {
    "id": "hvac-heat-pump-repair",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Heat pump repair",
    "slug": "heat-pump-repair",
    "excerpt": "Heat pump repair by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "DeviceThermostat",
    "pageUrl": "https://www.ritehvacservices.com/services/heat-pump-repair",
    "imageUrl": HeatPumpRepair
  },
  {
    "id": "hvac-furnace-services",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Furnace services",
    "slug": "furnace-services",
    "excerpt": "Furnace services by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Whatshot",
    "pageUrl": "https://www.ritehvacservices.com/services/furnace-services",
    "imageUrl": FurnaceServices
  },
  {
    "id": "hvac-iwave-furnace-installation-and-service",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "iWave furnace installation and service",
    "slug": "iwave-furnace-installation-and-service",
    "excerpt": "iWave furnace installation and service by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Air",
    "pageUrl": "https://www.ritehvacservices.com/services/iwave-furnace-installation-and-service",
    "imageUrl": iWaveFurnace
  },
  {
    "id": "hvac-heater-repair",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Heater repair",
    "slug": "heater-repair",
    "excerpt": "Heater repair by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "BuildCircle",
    "pageUrl": "https://www.ritehvacservices.com/services/heater-repair",
    "imageUrl": HeaterRepair
  },
  {
    "id": "hvac-heater-installation",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Heater installation",
    "slug": "heater-installation",
    "excerpt": "Heater installation by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "AddCircle",
    "pageUrl": "https://www.ritehvacservices.com/services/heater-installation",
    "imageUrl": HeaterInstallation
  },
  {
    "id": "hvac-green-heating-and-cooling-systems",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Green heating & cooling systems",
    "slug": "green-heating-and-cooling-systems",
    "excerpt": "Green heating & cooling systems by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "EnergySavingsLeaf",
    "pageUrl": "https://www.ritehvacservices.com/services/green-heating-and-cooling-systems",
    "imageUrl": GreenHeating
  },
  {
    "id": "hvac-high-velocity-systems",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "High-velocity systems",
    "slug": "high-velocity-systems",
    "excerpt": "High-velocity systems by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Speed",
    "pageUrl": "https://www.ritehvacservices.com/services/high-velocity-systems",
    "imageUrl": HighVelocitySystems
  },
  {
    "id": "hvac-indoor-air-quality",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Indoor air quality",
    "slug": "indoor-air-quality",
    "excerpt": "Indoor air quality by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "FilterAlt",
    "pageUrl": "https://www.ritehvacservices.com/services/indoor-air-quality",
    "imageUrl": IndoorAirQuality
  },
  {
    "id": "hvac-emergency-hvac",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Emergency HVAC",
    "slug": "emergency-hvac",
    "excerpt": "Emergency HVAC by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "FlashOn",
    "pageUrl": "https://www.ritehvacservices.com/services/emergency-hvac",
    "imageUrl":EmergencyHVAC
  },
  {
    "id": "hvac-duct-cleaning",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Duct cleaning",
    "slug": "duct-cleaning",
    "excerpt": "Duct cleaning by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "CleaningServices",
    "pageUrl": "https://www.ritehvacservices.com/services/duct-cleaning",
    "imageUrl": DuctCleaning
  },
  {
    "id": "hvac-thermostat-installation",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Thermostat installation",
    "slug": "thermostat-installation",
    "excerpt": "Thermostat installation by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Thermostat",
    "pageUrl": "https://www.ritehvacservices.com/services/thermostat-installation",
    "imageUrl": ThermostatInstallation
  },
  {
    "id": "hvac-energy-efficiency-audits",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Energy efficiency audits",
    "slug": "energy-efficiency-audits",
    "excerpt": "Energy efficiency audits by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Assessment",
    "pageUrl": "https://www.ritehvacservices.com/services/energy-efficiency-audits",
    "imageUrl": hvacEnergyEfficiencyAudits
  },
  {
    "id": "hvac-zoning-system-setup",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Zoning system setup",
    "slug": "zoning-system-setup",
    "excerpt": "Zoning system setup by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "GridView",
    "pageUrl": "https://www.ritehvacservices.com/services/zoning-system-setup",
    "imageUrl": ZoningSystemSetup
  },
  {
    "id": "hvac-commercial-hvac-maintenance",
    "mainType": "HVAC",
    "websiteServicesUrl": "https://www.ritehvacservices.com/services",
    "title": "Commercial HVAC maintenance",
    "slug": "commercial-hvac-maintenance",
    "excerpt": "Commercial HVAC maintenance by certified technicians in Bloomington IN. Fast response, fair pricing, and long-lasting results.",
    "description": null,
    "options": [],
    "tags": [],
    "price": "Typical visits start at $89 for diagnostics. Written quotes provided before work begins.",
    "icon": "Business",
    "pageUrl": "https://www.ritehvacservices.com/services/commercial-hvac-maintenance",
    "imageUrl": CommercialHVACMaintenance
  },
  {
    "id": "restoration-water-extraction-structural-drying",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Water Extraction & Structural Drying",
    "slug": "water-extraction-structural-drying",
    "excerpt": "Water Extraction & Structural Drying for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/water-extraction-structural-drying",
    "imageUrl": WaterExtractiontructuralDrying  
  },
  {
    "id": "restoration-dehumidification-air-movers",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Dehumidification & Air Movers",
    "slug": "dehumidification-air-movers",
    "excerpt": "Dehumidification & Air Movers for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/dehumidification-air-movers",
    "imageUrl": DehumidificationAndAirMovers
  },
  {
    "id": "restoration-mold-prevention-remediation",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Mold Prevention & Remediation",
    "slug": "mold-prevention-remediation",
    "excerpt": "Mold Prevention & Remediation for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/mold-prevention-remediation",
    "imageUrl": MoldPreventionRemediation
  },
  {
    "id": "restoration-sewage-cleanup-black-water",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Sewage Cleanup (Black Water)",
    "slug": "sewage-cleanup-black-water",
    "excerpt": "Sewage Cleanup (Black Water) for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/sewage-cleanup-black-water",
    "imageUrl": SewageCleanup
  },
  {
    "id": "restoration-content-cleaning-pack-out",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Content Cleaning & Pack Out",
    "slug": "content-cleaning-pack-out",
    "excerpt": "Content Cleaning & Pack Out for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/content-cleaning-pack-out",
    "imageUrl": ContentCleaning
  },
  {
    "id": "restoration-drywall-flooring-repair",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Drywall & Flooring Repair",
    "slug": "drywall-flooring-repair",
    "excerpt": "Drywall & Flooring Repair for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/drywall-flooring-repair",
    "imageUrl": DrywallAndFlooringRepair
  },
  {
    "id": "restoration-emergency-tarps-roof-leak-response",
    "mainType": "Water Restoration",
    "websiteServicesUrl": "https://ritewaterrestoration.com/services",
    "title": "Emergency Tarps & Roof Leak Response",
    "slug": "emergency-tarps-roof-leak-response",
    "excerpt": "Emergency Tarps & Roof Leak Response for homes and businesses across Bloomington, Monroe County, and nearby cities.",
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritewaterrestoration.com/services/emergency-tarps-roof-leak-response",
    "imageUrl":EmergencyTarps
  },
  {
    "id": "cleaning-house-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "House Cleaning",
    "slug": "house-cleaning",
    "excerpt": "Reliable weekly, bi-weekly, or one-time home cleanings in Bloomington.",
    "description": null,
    "options": [],
    "tags": [
      "Recurring",
      "One‑time",
      "Eco‑friendly",
      "Pet‑friendly"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/house-cleaning",
    "imageUrl": HouseCleaning
  },
  {
    "id": "cleaning-apartment-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Apartment Cleaning",
    "slug": "apartment-cleaning",
    "excerpt": "Flexible apartment and condo cleaning near IU & downtown.",
    "description": null,
    "options": [],
    "tags": [
      "Students",
      "Downtown",
      "Property managers"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/apartment-cleaning",
    "imageUrl": ApartmentCleaning
  },
  {
    "id": "cleaning-office-cleaning-services",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Office Cleaning Services",
    "slug": "office-cleaning-services",
    "excerpt": "A spotless workplace that impresses clients and supports productivity.",
    "description": null,
    "options": [],
    "tags": [
      "After‑hours",
      "Restrooms",
      "Break room",
      "Conference rooms"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/office-cleaning-services",
    "imageUrl":OfficeCleaning
  },
  {
    "id": "cleaning-deep-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Deep Cleaning",
    "slug": "deep-cleaning",
    "excerpt": "A top‑to‑bottom clean for kitchens, baths, and hard‑to‑reach areas.",
    "description": null,
    "options": [],
    "tags": [
      "Baseboards",
      "Inside oven",
      "Detailing"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/deep-cleaning",
    "imageUrl": DeepCleaning
  },
  {
    "id": "cleaning-commercial-cleaning-projects",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Commercial Cleaning Projects",
    "slug": "commercial-cleaning-projects",
    "excerpt": "Specialty and large‑scale cleanups tailored for businesses.",
    "description": null,
    "options": [],
    "tags": [
      "Construction",
      "Annual deep clean",
      "Floor care"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/commercial-cleaning-projects",
    "imageUrl": CommercialCleaning 
  },
  {
    "id": "cleaning-vacation-house-checks",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Vacation House Checks",
    "slug": "vacation-house-checks",
    "excerpt": "Peace of mind while you’re away from your Bloomington home.",
    "description": null,
    "options": [],
    "tags": [
      "Mail",
      "Plants",
      "Security"
    ],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/vacation-house-checks",
    "imageUrl": VacationHouseChecks
  },
  {
    "id": "cleaning-dusting-polishing",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Dusting & Polishing",
    "slug": "dusting-polishing",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/dusting-polishing",
    "imageUrl": DustingAndPolishing,
    "isSubService": true
  },
  {
    "id": "cleaning-vacuuming-mopping",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Vacuuming & Mopping",
    "slug": "vacuuming-mopping",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/vacuuming-mopping",
    "imageUrl":VacuumingAndMopping,
    "isSubService": true
  },
  {
    "id": "cleaning-bathrooms-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Bathrooms Cleaning",
    "slug": "bathrooms-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/bathrooms-cleaning",
    "imageUrl": BathroomsCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-mirrors-fixtures",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Mirrors & Fixtures",
    "slug": "mirrors-fixtures",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/mirrors-fixtures",
    "imageUrl": MirrorsFixtures,
    "isSubService": true
  },
  {
    "id": "cleaning-countertops-kitchen-surfaces",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Countertops & Kitchen Surfaces",
    "slug": "countertops-kitchen-surfaces",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/countertops-kitchen-surfaces",
    "imageUrl": CountertopsKitchenSurfaces,
    "isSubService": true
  },
  {
    "id": "cleaning-blinds-baseboards",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Blinds & Baseboards",
    "slug": "blinds-baseboards",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/blinds-baseboards",
    "imageUrl": BlindsBaseboards,
    "isSubService": true
  },
  {
    "id": "cleaning-spring-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Spring Cleaning",
    "slug": "spring-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/spring-cleaning",
    "imageUrl": SpringCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-pre-sale-house-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Pre-sale House Cleaning",
    "slug": "pre-sale-house-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/pre-sale-house-cleaning",
    "imageUrl": HouseCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-move-in-move-out-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Move-in / Move-out Cleaning",
    "slug": "move-in-move-out-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/move-in-move-out-cleaning",
    "imageUrl": MoveinMoveoutCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-event-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Event Cleaning",
    "slug": "event-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/event-cleaning",
    "imageUrl": EventCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-trash-removal-office",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Trash Removal (Office)",
    "slug": "trash-removal-office",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/trash-removal-office",
    "imageUrl": TrashRemoval,
    "isSubService": true
  },
  {
    "id": "cleaning-break-room-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Break Room Cleaning",
    "slug": "break-room-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/break-room-cleaning",
    "imageUrl": BreakRoom,
    "isSubService": true
  },
  {
    "id": "cleaning-conference-room-cleaning",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Conference Room Cleaning",
    "slug": "conference-room-cleaning",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/conference-room-cleaning",
    "imageUrl": Conference,
    "isSubService": true
  },
  {
    "id": "cleaning-annual-deep-cleaning-commercial",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Annual Deep Cleaning (Commercial)",
    "slug": "annual-deep-cleaning-commercial",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/annual-deep-cleaning-commercial",
    "imageUrl": DeepCleaning,
    "isSubService": true
  },
  {
    "id": "cleaning-vacation-house-check-mail-plants-storm-damage-security-check",
    "mainType": "Cleaning",
    "websiteServicesUrl": "https://ritecleaningservice.com/services",
    "title": "Vacation House Check: Mail, Plants, Storm Damage, Security Check",
    "slug": "vacation-house-check-mail-plants-storm-damage-security-check",
    "excerpt": null,
    "description": null,
    "options": [],
    "tags": [],
    "price": null,
    "icon": null,
    "pageUrl": "https://ritecleaningservice.com/services/vacation-house-check-mail-plants-storm-damage-security-check",
    "imageUrl":Vacation,
    "isSubService": true
  }
];

export default servicesData;
